import { TypeDestino } from "../../../Models/Domain/Viagem/Destino";
import { Axios } from "../../Axios";

export class DestinoService {

    public listarDestinos(filtro?: TypeDestino){
        return Axios.post<TypeDestino[]>(`quiron/viagem/destinos/listar`, filtro);
    }

    public inserirDestino(payload: TypeDestino) {
        return Axios.post<TypeDestino>(`quiron/viagem/destinos`, payload);
    }

    public atualizarDestino(payload: TypeDestino) {
        return Axios.put<void>(`quiron/viagem/destinos`, payload);
    }

    public ativarDestino(codigo: number) {
        return Axios.patch(`quiron/viagem/destinos/${codigo}/ativar`);
    }

    public desativarDestino(codigo: number) {
        return Axios.patch(`quiron/viagem/destinos/${codigo}/desativar`);
    }

}

export default DestinoService;